import { supabase } from '../supabaseClient';

/* Accès aux données « boamp-documents_storage ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function uploadTenderDocumentFile(file, storagePath) {
  return supabase.storage
    .from('boamp-documents')
    .upload(storagePath, file, { contentType: file.type || 'application/pdf' });
}

export function removeTenderDocumentFiles(doc) {
  return supabase.storage.from('boamp-documents').remove([doc.storage_path]);
}
